import { useEffect, useState } from 'react';
import './App.css';
import About from './components/about/About';
import Home from './components/home/Home';
import Navbar from "./components/navbar/Navbar"
import {
  BrowserRouter,
  Route,
  Routes
} from "react-router-dom";
import Footer from './components/footer/Footer';
import Project from './components/Project/Project';
import Contact from './components/contact/Contact';

function App() {
  
  return (
    <BrowserRouter>
    <Navbar /> 
      <Routes>
        <Route path="/" index element={<Home />}/>
        <Route path="contact" element={<Contact />} />
        <Route path="project" element={<Project/>} />
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
